"use client";

import { IoMdSearch, IoMdMore } from "react-icons/io";

import { NextImage } from "@/components/NextImage";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useWhatsappData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";

import "./WhatsappTemplate.scss";

export const WhatsappTemplate = (props: QRProps<"whatsapp">) => {
  const { data, isInitialPreview, message } = useWhatsappData(props);

  if (!data) {
    return null;
  }

  return (
    <PhoneLayout
      page="whatsapp"
      dataQA="preview-whatsapp-container"
      backgroundColor={"white"}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser={false}
    >
      <div className="whatsapp-template">
        <div className="whatsapp-template__header">
          <div className="whatsapp-template__header-title">Whatsapp</div>
          <div className="whatsapp-template__header-icons">
            <IoMdSearch />
            <IoMdMore />
          </div>
        </div>
        <div className="whatsapp-template__chat">
          <div className="whatsapp-template__chat-message">
            <NextImage
              src="/images/phone-previews/defaultPreview/emoji.png"
              width={24}
              height={24}
              alt="emoji smiley face"
            />
            <p className="whatsapp-template__message">{message}</p>
            <NextImage
              src="/images/phone-previews/defaultPreview/attach.png"
              width={24}
              height={24}
              alt="emoji attach file"
            />
          </div>
          <NextImage
            src="/images/phone-previews/defaultPreview/send.png"
            width={40}
            height={40}
            alt="send icon"
            className="whatsapp-template__chat-send"
          />
        </div>
      </div>
    </PhoneLayout>
  );
};
